module.exports = __webpack_public_path__ + "static/media/black.3aedca1f.svg";